import {
  Close,
  Save as SaveIcon,
  Search as SearchIcon,
} from '@mui/icons-material'
import { Box, IconButton, Tooltip } from '@mui/material'
import { useCallback, useState } from 'react'
import { ColumnConfigurationIcon, DownloadIcon, SearchIconBtn } from '../../../../assets/icons'
import {
  VENDOR_DETAILS_COLUMNS,
  VENDOR_DETAILS_SEARCH_FIELDS,
  VENDOR_LDC_SEARCH_FIELDS,
  VENDOR_MASTER_TABS,
} from '../../../../constants/define'
import ColumnConfiguration from '../../../common/columnConfiguration.jsx'
import { CommonTabs, Search, ConfirmationDialog } from '../../../common/index.js'
import KeyFilter from '../common/KeyFilter.jsx'
import EditIcon from '../../../../assets/icons/EditIcon.jsx'
import DeleteIcon from '../../../../assets/icons/DeleteIcon.jsx'
import StyledSwitch from '../../../common/StyledSwitch.jsx'



const VendorMaster = () => {
  // State
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [isEditMode, setIsEditMode] = useState(false)
  const [isCloseEditMode, setCloseEditMode] = useState(false)
  const [editEnabled, setEditEnabled] = useState(false)
  const [showTable, setShowTable] = useState(false)
  const [searchOpen, setSearchOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [searchAction, setSearchAction] = useState(0)
  const [searchFieldColumns, setSearchFieldColumns] = useState(
    VENDOR_DETAILS_SEARCH_FIELDS
  )
  const [searchCriteria, setSearchCriteria] = useState([
    {
      id: 1,
      logicalOperator: 'Where',
      field: VENDOR_DETAILS_SEARCH_FIELDS[0]?.id || '',
      value: '',
    },
  ])
  const [searchCOList, setSearchCOList] = useState([
    {
      id: 1,
      logicalOperator: 'Where',
      field: VENDOR_DETAILS_SEARCH_FIELDS[0]?.id || '',
      value: '',
    },
  ])
  const [downloadExcel, setDownloadExcel] = useState(0)
  const [deleteData, setDeleteData] = useState(0)
  const [tanUuid, setTanUuid] = useState('')
  const [columnConfigOpen, setColumnConfigOpen] = useState(false)
  const [columnConfigAnchor, setColumnConfigAnchor] = useState(null)

  const [visibleColumns, setVisibleColumns] = useState(
    VENDOR_DETAILS_COLUMNS.map(col => col.id)
  )

  const [triggerSave, setTriggerSave] = useState(0)
  const [disabled, setDisabled] = useState(true)

  const [confirmOpen, setConfirmOpen] = useState(false)
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    confirmText: 'Proceed',
  })
  const [pendingDelete, setPendingDelete] = useState(false)
  const [isMonthlyView, setIsMonthlyView] = useState(false)
  const [monthlyToggleHandler, setMonthlyToggleHandler] = useState(null)



  const handleTableDataSave = () => {
    setTriggerSave(Date.now())
  }

  // Handlers
  const handleTabChange = newIndex => {
    setIsEditMode(false)
    setActiveTabIndex(newIndex)
    setSearchFieldColumns(
      newIndex === 0 ? VENDOR_DETAILS_SEARCH_FIELDS : VENDOR_LDC_SEARCH_FIELDS
    )
    setSearchCriteria([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(newIndex)[0]?.id || '',
        value: '',
      },
    ])
    setSearchCOList([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(newIndex)[0]?.id || '',
        value: '',
      },
    ])
    setVisibleColumns(
      newIndex === 0
        ? VENDOR_DETAILS_SEARCH_FIELDS.map(col => col.id)
        : VENDOR_LDC_SEARCH_FIELDS.map(col => col.id)
    )
    setTriggerSave(0)
    setDeleteData(0)
    setDownloadExcel(0)
  }

  const handleTableDataEdit = () => {
    setIsEditMode(true)
    setDownloadExcel(0)
  }

  const handleActiveTabData = useCallback(data => {
    if (data?.type === 'editEnabled') setEditEnabled(data.value)
    if (data?.type === 'monthlyToggle') {
      setIsMonthlyView(data.value)
      if (data.handler) setMonthlyToggleHandler(() => data.handler)
    }
  }, [])

  const handleViewClick = data => {
    setDownloadExcel(0)
    // Reset monthly view toggle when TAN changes so it doesn't persist across selections
    setIsMonthlyView(false)
    if (monthlyToggleHandler) monthlyToggleHandler(false)
    setTanUuid(data.tanMasterUuid)
    setShowTable(true)
    setSearchCriteria([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
    setSearchCOList([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
  }

  const handleCloseSearch = () => {
    setSearchOpen(false)
    setAnchorEl(null)
    setSearchCriteria([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
    setSearchCOList([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
    setDownloadExcel(0)
  }

  const handleApplySearch = async searchList => {
    // Map fieldName to field for UI
    const mappedCriteria = searchList.map((item, idx) => ({
      ...item,
      field: item.fieldName || item.field || '',
      id: idx + 1,
      logicalOperator: item.logicalOperator || (idx === 0 ? 'Where' : 'And'),
    }))
    setSearchCriteria(mappedCriteria)
    setSearchCOList(searchList)
    setSearchAction(Date.now())
    setSearchOpen(false)
  }

  const handleResetSearch = async () => {
    setSearchCriteria([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
    setSearchCOList([
      {
        id: 1,
        logicalOperator: 'Where',
        field: getActiveTabSearchFields(activeTabIndex)[0]?.id || '',
        value: '',
      },
    ])
    setSearchAction(Date.now())
    setSearchOpen(false)
    setDownloadExcel(0)
  }

  const handleSearch = event => {
    setDownloadExcel(0)
    setSearchOpen(!searchOpen)
    setAnchorEl(event.currentTarget)
  }

  const handleExcelDownload = () => {
    setDownloadExcel(Date.now())
  }

  const handleDelete = () => {
    setDeleteData(Date.now())
    setConfirmOpen(false)
  }

  const getActiveTabSearchFields = activeIndex => {
    return activeIndex === 0
      ? VENDOR_DETAILS_SEARCH_FIELDS
      : VENDOR_LDC_SEARCH_FIELDS
  }

  const handleColumnChange = selectedColumns => {
    setVisibleColumns(selectedColumns)
    setDownloadExcel(0)
  }

  const handleColumnConfigurationClose = () => {
    setColumnConfigOpen(false)
    setColumnConfigAnchor(null)
  }

  const handleCloseEditMode = () => {
    setIsEditMode(false)
    setCloseEditMode(true)
    setEditingData({})
    setDownloadExcel(0)
  }

  const handleColumnConfigOpen = event => {
    setColumnConfigAnchor(event.currentTarget)
    setColumnConfigOpen(!columnConfigOpen)
    setDownloadExcel(0)
  }

  // inside VendorMaster
  const [editingData, setEditingData] = useState({})

  const handleFieldChange = (rowId, field, value) => {
    setEditingData(prev => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [field]: value,
      },
    }))
  }




  const getTabActions = () => {
    return (
      <>
        {activeTabIndex === 1 && (
          <Tooltip title={isMonthlyView ? 'Yearly View' : 'Monthly View'}>
            <span style={{ display: 'inline-flex', alignItems: 'center', marginRight: 4 }}>
              <StyledSwitch
                size="small"
                checked={!!isMonthlyView}
                onChange={(e, checked) => {
                  if (monthlyToggleHandler) monthlyToggleHandler(checked)
                }}
              />
            </span>
          </Tooltip>
        )}
        <Tooltip title="Column Configuration">
          <IconButton

            onClick={handleColumnConfigOpen}
          >
            <ColumnConfigurationIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download Excel">
          <IconButton

            onClick={handleExcelDownload}
          >
            <DownloadIcon />
          </IconButton>
        </Tooltip>
        {!isEditMode && (
          <Tooltip title="Edit">
            <span>
              <IconButton
                sx={{
                  color: 'var(--forbrand-primary)',
                }}
                // disabled={!editEnabled}
                onClick={handleTableDataEdit}
              >
                <EditIcon />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {isEditMode && (
          <Tooltip title="Save">
            <IconButton
              sx={{
                color: 'var(--forbrand-primary)',
              }}
              onClick={handleTableDataSave}
            >
              <SaveIcon />
            </IconButton>
          </Tooltip>
        )}
        {isEditMode && (
          <Tooltip title="Cancel">
            <IconButton
              sx={{
                color: 'var(--forbrand-primary)',
              }}
              onClick={handleCloseEditMode}
            >
              <Close />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Search">
          <IconButton
            sx={{
              color: 'var(--forbrand-primary)',
            }}
            onClick={handleSearch}
          >
            <SearchIconBtn />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton
            sx={{
              color: 'var(--forbrand-error)',
            }}
            onClick={() => {
              setConfirmOpen(true)
              setPendingDelete(true)
            }}
            disabled={disabled}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </>
    )
  }

  // Variables + Constants
  const tabsWithProps = VENDOR_MASTER_TABS.map(tab => {
    switch (tab.label) {
      case 'Vendor Details':
      case 'Vendor LDC Details':
        return {
          ...tab,
          props: {
            isEditMode: isEditMode,
            editingData,
            onFieldChange: handleFieldChange,
            onActiveTabData: handleActiveTabData,
            searchCOList: searchCOList,
            searchAction: searchAction,
            tanUuid,
            downloadExcel: downloadExcel,
            deleteData: deleteData,
            isCloseEditMode,
            visibleColumns,
            triggerSave,
            pendingDelete,
            confirmOpen,
            setTriggerSave,
            setEditingData,
            setIsEditMode,
            handleTableDataSave,
            setDownloadExcel,
            setDisabled,
            setConfirmConfig,
            setConfirmOpen,
            setDeleteData,
          },
        }
      default:
        return { ...tab }
    }
  })
  const ActiveTab = tabsWithProps[activeTabIndex].content
  const activeTabProps = tabsWithProps[activeTabIndex].props

  return (
    <>
      {/* Key Filters */}
      <KeyFilter handleViewClick={handleViewClick} />
      {/* Tab Menu */}
      {showTable && (
        <Box sx={{ mt: 2 }}>
          <CommonTabs
            tabs={tabsWithProps}
            activeIndex={activeTabIndex}
            actions={getTabActions()}
            onTabChange={handleTabChange}
          />
          {/* Active Tab */}
          <ActiveTab {...activeTabProps} />
        </Box>
      )}
      {/* Search Component */}
      <Search
        placement="bottom-start"
        open={searchOpen}
        searchCriteria={searchCriteria}
        anchorEl={anchorEl}
        fields={searchFieldColumns}
        onClose={handleCloseSearch}
        onApply={handleApplySearch}
        onReset={handleResetSearch}
        setSearchCriteria={setSearchCriteria}
      />
      {/* Column Configuration Component */}

      <ColumnConfiguration
        columns={tabsWithProps[activeTabIndex].columns}
        visibleColumns={visibleColumns}
        anchorEl={columnConfigAnchor}
        open={columnConfigOpen}
        onColumnChange={handleColumnChange}
        onClose={handleColumnConfigurationClose}
      />

      <ConfirmationDialog
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleDelete}
        title={confirmConfig.title}
        message={confirmConfig.message}
        confirmText={confirmConfig.confirmText}
        type="delete"
        showCancelButton={true}
      />

    </>
  )
}

export default VendorMaster
